import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import FolderForms from "./FolderForms";

// const FolderForms = React.lazy(() => import("./FolderForms"));

export const FolderFormsRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <FolderForms />
    </Suspense>
  );
};
